"use client";

import { useAuth } from "@/components/auth-provider";
import { ReCaptcha } from "@/components/recapcha";
import { ContactForm } from "./contact-form";
import { FAQSection } from "./faq-section";

export function ContactUsPageClient() {
  const { profile } = useAuth();

  return (
    <ReCaptcha>
      <ContactForm defaultEmail={profile?.email} />
      <FAQSection />
    </ReCaptcha>
  );
}
